import PropTypes from "prop-types";
import React, {PureComponent} from "react";
import {connect} from "react-redux";

import {ActionCreator} from "../reducers/application/application";
import {Archive} from "./archive";
import {Header} from "./header";
import {MapPool} from "./map-pool";
import {PoolPropType} from "../prop-types";
import {Sidebar} from "./sidebar";
import {getPoolById} from "../reducers/data/selectors";


class PoolPageComponent extends PureComponent {
  constructor(props) {
    super(props);

    this._applyComponent();
    this._applyComponent = this._applyComponent.bind(this);
  }

  componentDidUpdate() {
    this._applyComponent();
  }

  _applyComponent() {
    const poolId = this.props.pool.id;
    const areaId = this.props.areaId;

    this.props.onPageLoad(poolId, areaId);
  }

  render() {
    const title = this.props.pool.title;

    return (
      <main className="main">
        <div className="main__sidebar">
          <Sidebar />
        </div>

        <div className="main__page-content">
          <section className="page-content">
            <h2 className="visually-hidden">Блок карты</h2>

            <Header title={title} />
            <MapPool />
            <Archive />
          </section>
        </div>
      </main>
    );
  }
}


PoolPageComponent.propTypes = {
  routeProps: PropTypes.object.isRequired,
  pool: PoolPropType.isRequired,
  areaId: PropTypes.string.isRequired,
  onPageLoad: PropTypes.func.isRequired,
};


const mapStateToProps = (state, props) => {
  const {routeProps} = props;
  const poolId = routeProps.match.params.id;
  const areaId = routeProps.match.params.areaId || ``;

  return {
    pool: getPoolById(state, poolId),
    areaId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onPageLoad(poolId, areaId) {
    dispatch(ActionCreator.setActivePoolId(poolId));
    dispatch(ActionCreator.setActiveAreaId(areaId));
  },
});

const PoolPage = connect(mapStateToProps, mapDispatchToProps)(PoolPageComponent);


export {
  PoolPageComponent,
  PoolPage,
};
